export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    getCommentList: function getCommentList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/comment/get",
        method: "get",
        params: data
      });
    },
    deleteComment: function deleteComment() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/comment/delete",
        method: "post",
        data: data
      });
    },
    getCheckPendingCommentList: function getCheckPendingCommentList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/comment/getCheckPendingList",
        method: "get",
        params: data
      });
    },
    auditComment: function auditComment() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/admin/comment/audit",
        method: "post",
        data: data
      });
    }
  };
});